import { useState } from 'react';
import PropTypes from 'prop-types';

import { AddToFolderIcon, OverlayTriggerTooltip } from '@utilities';

import ModalAddToFolder from './components/ModalAddToFolder';

const AddToFolder = ({ reportId }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <>
      <OverlayTriggerTooltip aria-label="Add to Folder" content="Add to Folder">
        <button data-testid="add-to-folder-cta" onClick={() => setIsActive(true)}>
          <AddToFolderIcon />
        </button>
      </OverlayTriggerTooltip>

      {isActive && <ModalAddToFolder onClose={() => setIsActive(false)} reportId={reportId} />}
    </>
  );
};

AddToFolder.propTypes = {
  reportId: PropTypes.number,
};

export default AddToFolder;
